import { MaskType } from "../../../screens/Dashboard/SubComponents/Studio/interfaces/sub-interfaces/Mask.interface";

import type { IStudio } from "../../../screens/Dashboard/SubComponents/Studio/interfaces/Studio.interface";

/**
 * ¿La escena tiene ALGO para dibujar?
 *
 * Es el test que decide si el render cae en las barras de color (test pattern).
 * Vive afuera de RenderFactory porque la respuesta correcta no es obvia: las
 * escenas gráficas armadas desde un scene-template (Inicio / Pausa / Cierre)
 * salen con `areas: []`, sin `theme` y — cuando el diseño no tiene textos
 * editables ni widgets — también sin `elements`. Todo su contenido vive en
 * `studio.mask`. Contar sólo áreas/fondo/widgets/elements las declaraba vacías
 * y las pintaba con barras verticales: un diseño válido que parecía roto.
 */
export const sceneHasRenderableContent = (
  model: Pick<IStudio, "areas" | "theme" | "widgets" | "elements" | "mask">
): boolean => {
  if ((model.areas?.length ?? 0) > 0) return true;

  if (model.theme?.background !== undefined) return true;

  if ((model.widgets?.length ?? 0) > 0) return true;

  if ((model.elements?.length ?? 0) > 0) return true;

  const mask = model.mask;

  if (!mask) return false;

  return mask.type === MaskType.composition ? Boolean(mask.overlay) : Boolean(mask.src);
};
